import React from "react";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { CURRENT_USER } from "../api/queries/currentUser";
// Hide featured students for now
//import { FeaturedStudentsWrapper } from "@/components/FeaturedStudentsWrapper";
import { MostEngagedStudents } from "@/components/MostEngagedStudents";
import { useOrg } from "@/hooks/useOrg";
import { DashboardOverviewDataCells } from "@/components/DashboardOverviewDataCells";
import { HalfFunnelChartContainer } from "@/components/HalfFunnelChart";
import { MiniChart } from "@/components/CommunityGrowthChart/MiniChart";
import { Bouncer } from "@/components/Bouncer";
import { RecentlyJoinedCarousel } from "@/components/RecentlyJoinedCarousel";

const date = new Date();
const formattedDate = date.toLocaleDateString("en-US", {
  month: "long",
  year: "numeric",
  day: "numeric",
});

export function Home() {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery(CURRENT_USER, {
    fetchPolicy: "network-only",
  });
  const { org, loading: orgLoading, error: orgError } = useOrg();

  if (loading) return <Bouncer />;
  if (error) return <div>{t("error.user")}</div>;

  return (
    <>
      <div className="w-full border-b p-6 pb-4">
        <h1 className="text-2xl font-bold text-foreground">
          {t("home.welcome", { name: data?.me?.firstName })}
        </h1>
        <h2 className="text-lg text-muted-foreground">{formattedDate}</h2>
      </div>
      <div className="flex flex-col gap-6 p-6">
        <DashboardOverviewDataCells
          orgId={org?.id}
          orgIdLoading={orgLoading}
          orgIdError={orgError}
        />
        <RecentlyJoinedCarousel
          title={t("home.studentCarousel.title")}
          viewAllSource="Community Snapshot - Recently Joined"
          profileSource="Community Snapshot - New Students in Your Community"
        />
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
          <MiniChart />
          <HalfFunnelChartContainer />
        </div>
        {/* Don't display the featured student wrapper until the backend is ready
        <FeaturedStudentsWrapper organizationId={org?.id || ""} />
        */}
        <MostEngagedStudents />
      </div>
    </>
  );
}
